import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface usersState {
	isLoading: boolean;
	usersList: any;
	usersDetail: any;
	totalUsers: number;
	userOrder: any;
	orderLoading: boolean;
	totalorderList : number
}

const initialState: usersState = {
	isLoading: false,
	usersDetail: {},
	usersList: [],
	totalUsers: 0,
	userOrder: [],
	orderLoading: false,
	totalorderList : 0
};

const usersSlice = createSlice({
	name: 'users',
	initialState,
	reducers: {
		getAllUsersListInIt: state => {
			state.isLoading = true;
		},
		getAllUsersListSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			// console.log(data);

			state.isLoading = false;
			state.totalUsers = data.count;
			state.usersList = [...data.customers];
		},
		getAllUsersListError: state => {
			state.isLoading = false;
			state.usersList = [];
			state.totalUsers = 0;
		},
		deleteUsersInit: state => {
			state.isLoading = true;
		},
		deleteUsersSuccess: state => {
			// state.isLoading = false;
		},
		deleteUsersError: state => {
			state.isLoading = false;
		},
		getUsersByIdInIt: state => {
			state.isLoading = true;
		},
		getUsersByIdSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.usersDetail = { ...action.payload.data };
		},
		getUsersByIdError: state => {
			state.isLoading = false;
		},
		clearUsersDetail: state => {
			state.usersDetail = {};
		},
		addUsersInIt: state => {
			state.isLoading = true;
		},
		addUsersSuccess: state => {
			state.isLoading = false;
		},
		addUsersError: state => {
			state.isLoading = false;
		},
		updateUserStatusInit: state => {
			state.isLoading = true;
		},
		updateUserStatusSuccess: state => {
			// state.isLoading = true;
		},
		updateUserStatusError: state => {
			state.isLoading = false;
		},
		getUserOrderDetailInIt: state => {
			state.orderLoading = true;
		},
		getUserOrderDetailSuccess: (state, action: PayloadAction<any>) => {
			console.log(action.payload);

			state.orderLoading = false;
			state.userOrder = [...action.payload.data.response];
			state.totalorderList = action.payload.data.count
		},
		getUserOrderDetailError: state => {
			state.orderLoading = false;
			state.userOrder = [];
			state.totalorderList = 0
		}
	}
});

export const {
	getAllUsersListError,
	getAllUsersListInIt,
	getAllUsersListSuccess,
	deleteUsersError,
	deleteUsersInit,
	deleteUsersSuccess,
	getUsersByIdError,
	getUsersByIdInIt,
	getUsersByIdSuccess,
	addUsersError,
	addUsersInIt,
	addUsersSuccess,
	clearUsersDetail,
	updateUserStatusError,
	updateUserStatusInit,
	updateUserStatusSuccess,
	getUserOrderDetailError,
	getUserOrderDetailInIt,
	getUserOrderDetailSuccess
} = usersSlice.actions;

export default usersSlice.reducer;
